import { getAuth } from "firebase/auth";
import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
import Vuetify from "vuetify";
// import Wrestler from "./components/Wrestler.vue";
import VueRouter from "vue-router";
import VueMoment from "vue-moment";

Vue.use(Router);
Vue.use(Vuetify);
Vue.use(require("vue-moment"));

// Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./components/HelloWorld.vue"),
    },
    {
      path: "/wrestler/:wrestler",
      name: "wrestler",
      component: () => import("./components/Wrestler.vue"),
    },
    {
      path: "/wrestler/:wrestlerID/match/:matchID",
      name: "match",
      component: () => import("./components/Match.vue"),
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/sign-up",
      name: "SignUp",
      component: () => import("./views/SignUp.vue"),
    },
    {
      path: "/league/:leagueId/rankings",
      name: "league-rankings",
      component: () => import("./views/LeagueRankings.vue"),
    },
    {
      path: "/league/:leagueId/team",
      name: "league-team-lineup",
      component: () => import("./views/LeagueTeamLineup.vue"),
    },
    {
      path: "/league/:league/weight/:weight",
      name: "weight-class-rankings",
      component: () => import("./views/WeightClassRankings.vue"),
    },
    {
      path: "/manage/leagues",
      name: "league-manager",
      meta: { requiresAuth: true, requiresLeagueManager: true },
      component: () => import("./views/LeagueManager.vue"),
    },
    {
      path: "/user-guide",
      name: "user-guide",
      component: () => import("./views/UserGuide.vue"),
    },
    {
      path: "/admin",
      name: "admin-dashboard",
      meta: { requiresAuth: true, requiresLeagueManager: true },
      component: () => import("./views/AdminDashboard.vue"),
    },
  ],
});

const LEAGUE_MANAGER_EMAILS = ["ken@kennected.com", "kennected.com@gmail.com"];

function canAccessLeagueManager() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user || !user.email) return false;
  const email = user.email.trim().toLowerCase();
  return LEAGUE_MANAGER_EMAILS.some((e) => e.toLowerCase() === email);
}

router.beforeEach((to, from, next) => {
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresLeagueManager = to.matched.some(
    (record) => record.meta.requiresLeagueManager
  );

  if (requiresAuth && !currentUser) return next("login");
  if (requiresLeagueManager && !canAccessLeagueManager()) return next("/");
  next();
});

export default router;
